// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Checkmark';

interface CheckmarkProps {
  className?: string;
  title?: string;
}

export function CheckmarkStroke({ className, title }: CheckmarkProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title || TITLE}
    >
      <title>{title || TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10.126 18.0042L18 8.03048L16.4921 6.84L9.95682 15.118L7.35852 12.5197L6 13.8782L10.126 18.0042Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CheckmarkFilled({ className, title }: CheckmarkProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
    >
      <title>{title || TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.126 18.0042L18 8.03048L16.4921 6.84L9.95682 15.118L7.35852 12.5197L6 13.8782L10.126 18.0042Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Checkmark({ className, title }: CheckmarkProps) {
  const _title = title || TITLE;

  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label={_title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{_title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 4.68064L8.87668 21.3035L2 14.4268L4.26419 12.1626L8.59469 16.4931L19.4868 2.6965L22 4.68064Z"
        fill="currentColor"
      />
    </svg>
  );
}
